import ProductComparisonGrid from '@app/components/common/ProductComparisonGrid/ProductComparisonGrid';
import ProductListItemsCount from '@app/components/common/ProductListItemsCount';
import ProductListKey from '@app/components/common/ProductListKey';
import ProductListSortBy from '@app/components/common/ProductListSortBy';
import ProductSpecificationModalContainer from '../ProductSpecificationModalContainer';
import { PAGE_BREAKPOINTS, STATUS, UOM } from '@app/constants/commonConstants';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import { useBreakpoint, useEspot, useAnalytics } from '@app/hooks';
import {
  getMarketingProductDetails,
  marketingSetQueryParam,
  setMarketingProductCardExpanded
} from '@app/store/marketing/actions';
import { getPriceAndAvailability } from '@app/store/products/actions';
import { isEmpty } from '@app/utils';
import {
  AlloyButton,
  FilterIcon,
  Loader,
  ModalContext
} from 'cat-ecommerce-alloy';
import cx from 'classnames';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  MARKETING_PAGE_UNIQUEID,
  GA_TRACKING_MARKETING_PRODUCT_CARD,
  MARKETING_PRODUCT_PAGE_SIZE
} from '../../constants';
import { getPartNumbers } from '../../utils';
import ProductCardSidebar from './ProductCardSidebar/ProductCardSidebar';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import ProductListFilterBoxes from '@app/components/common/ProductListFilterBoxes';
import usePagination from '@app/components/pages/plp/usePagination';
import EquipmentNoResults from '@app/components/common/MyEquipmentFilter/EquipmentInformation/EquipmentNoResults/EquipmentNoResults';
import { getUrlByHashValue } from '@app/store/marketing/utils';
import { PRICE_AVAILABILITY_DEFAULT_ATTRIBUTE_PART_NUMBER } from '@app/store/products/constants';

const ProductCardGrid = props => {
  const widgetId = props.widgetId;
  const { addModalWithOptions, removeCurrentModal } = useContext(ModalContext);
  const partNumbersEspotName = props.widgetProps?.emsName;
  const widgetHeaderName = props.widgetProps?.productCardWidgetHeader;

  const [isOpen, setIsOpen] = useState(false);
  const [t] = useTranslation();
  const { fireProductImpressionEvent } = useAnalytics();
  const { setUrlToPageOneWithFilter } = usePagination();
  const { hash } = useLocation();
  const { filterByEquipment: filterByEquipmentUrl } = queryString.parse(hash);
  const { sortBy: orderByFromHashUrl } = queryString.parse(hash);
  const dispatch = useDispatch();
  const priceAndAvailibiltyStatus = useSelector(
    state =>
      state.marketingLandingPageUI[widgetId]?.getMarketingProductPriceStatus
  );
  const sortBy = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.sortBy
  );
  const getProductDetailsStatus = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.getProductDetailsStatus
  );
  const productCardExpandedArr = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.productCardExpandedArr
  );
  const batchPartNumbers = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.batchPartNumbers
  );
  const activeFacets = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.activeFacets
  );
  const unitOfMeasure = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.unitOfMeasure
  );
  const showSpecificationsToggle = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.showSpecificationsToggle
  );
  const recordSetTotal = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.recordSetTotal
  );
  const fireImpressionEvent = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.fireImpressionEvent
  );
  const filterByEquipment = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.filterByEquipment
  );
  const fbeEnabled = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.fbeEnabled
  );
  const pageNumber = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.pageNumber
  );
  const partNumbers = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.partNumbers
  );

  const facets = useSelector(
    state => state.marketingLandingPageUI[widgetId]?.facets
  );
  const { espotData } = useEspot(partNumbersEspotName);
  const getPartNumbersfromEspot = useCallback(() => {
    const partsObj = espotData?.[0] && espotData[0][partNumbersEspotName];
    let partnumbers = '';
    partsObj?.parts?.forEach(part => (partnumbers += `,${part.partNumber}`));
    return partnumbers.substring(1);
  }, [espotData]);
  const partNumber = getPartNumbersfromEspot();
  const { selectedEquipment } = useSelector(s => s.myEquipment.equipments);
  const getOrderByValueFromUrl = () => {
    const { sortBy: orderByFromHash } = queryString.parse(hash);
    let orderByValue = '0';
    if (orderByFromHash && orderByFromHash.includes(widgetId)) {
      orderByFromHash.split(',').forEach(item => {
        const widgetUrlValue = item.split('|');
        if (widgetUrlValue[1] == widgetId) {
          orderByValue = widgetUrlValue[0];
        }
      });
    }
    return orderByValue;
  };
  useEffect(() => {
    const orderByFromUrl = getOrderByValueFromUrl();
    dispatch(
      marketingSetQueryParam({
        widgetId: widgetId,
        isProductCardWidgetAvailable: true,
        data: {
          pageNumber: 1,
          getMarketingProductPriceStatus: STATUS.IDLE,
          getProductDetailsStatus: STATUS.IDLE,
          sortBy: orderByFromUrl,
          partNumbers: partNumber,
          current: '',
          unitOfMeasure: UOM.us,
          activeFacets: [],
          facets: [],
          showSpecificationsToggle: false
        }
      })
    );
  }, [widgetId, partNumber]);
  const getEspotProperties = useCallback(
    key => {
      const espotProperties =
        espotData?.[0] && espotData[0][partNumbersEspotName];
      let flag = 'false';
      espotProperties?.properties?.forEach(item => {
        if (item[key]) {
          flag = item[key];
        }
      });
      return flag;
    },
    [espotData, partNumbersEspotName]
  );
  const showLeftNav =
    getEspotProperties('enableMarketingPageFacets') === 'true';
  const showKeyComponent =
    getEspotProperties('enableMarketingPageKeyComponent') === 'true';

  const { byId: products, priceAndAvailability } = useSelector(
    state => state.products
  );
  const partNumbersArray = partNumber?.split(',');
  const productsArray = batchPartNumbers
    ?.map(part => {
      if (products[part]) {
        return products[part];
      }
    })
    .filter(item => item);
  const productsArrayLength = productsArray?.length;
  const currencyCode = useSelector(s => s.dealerCustomer?.currency) ?? '';

  useEffect(() => {
    fireImpressionEvent &&
      productsArrayLength &&
      fireProductImpressionEvent(
        GA_TRACKING_MARKETING_PRODUCT_CARD,
        productsArray,
        currencyCode
      );
    fireImpressionEvent &&
      productsArrayLength &&
      dispatch(
        marketingSetQueryParam({
          widgetId: widgetId,
          data: { fireImpressionEvent: false }
        })
      );
  }, [fireImpressionEvent, widgetId, productsArrayLength]);
  const hasCatalogEntries = !isEmpty(productsArray);
  useEffect(() => {
    partNumber &&
      dispatch(getMarketingProductDetails(partNumber, widgetId, true));
  }, [partNumber]);

  useEffect(() => {
    partNumber &&
      getProductDetailsStatus === STATUS.RESOLVED &&
      dispatch(
        getPriceAndAvailability({
          partsList: getPartNumbers(partNumber, productsArray),
          namespace: 'priceAndAvailability',
          statusActionPrefix: MARKETING_PAGE_UNIQUEID,
          errorInfo: {
            domain: ERROR_DOMAIN.MARKETING,
            path: ERROR_PATH.PRICE_AND_AVAILABILITY
          },
          widgetId,
          attributeId: PRICE_AVAILABILITY_DEFAULT_ATTRIBUTE_PART_NUMBER
        })
      );
  }, [partNumber, getProductDetailsStatus]);

  const handleSetExpanded = uniqueId => {
    dispatch(setMarketingProductCardExpanded(uniqueId, widgetId));
  };
  const loading = getProductDetailsStatus === STATUS.PENDING;
  const totalPartNumber = partNumbersArray?.length;
  const handleShowMoreClick = () => {
    dispatch(
      marketingSetQueryParam(
        {
          widgetId: widgetId,
          data: {
            pageNumber: pageNumber + 1
          }
        },
        true
      )
    );
  };
  const handleCancelButton = () => {
    removeCurrentModal();
  };
  const handleEquipmentCheck = useCallback(
    value => {
      dispatch(
        marketingSetQueryParam({
          widgetId: widgetId,
          data: {
            filterByEquipment: value,
            pageNumber: 1,
            batchPartNumbers: []
          }
        })
      );
      let activeFacetWithWidgetId = [];
      activeFacets?.forEach(item => {
        activeFacetWithWidgetId.push({ facet: `${item.facet}|${widgetId}` });
      });
      const filterByEqValue = widgetId
        ? getUrlByHashValue(value, widgetId, filterByEquipmentUrl)
        : value;
      const orderByValue = widgetId
        ? getUrlByHashValue(sortBy, widgetId, orderByFromHashUrl)
        : sortBy;

      setUrlToPageOneWithFilter({
        filterByEquipment: filterByEqValue,
        orderBy: orderByValue,
        fbeEnabledValue: fbeEnabled,
        isMarketingPage: true,
        facets: activeFacetWithWidgetId
      });
      dispatch(getMarketingProductDetails(partNumber, widgetId, true));
    },
    [
      dispatch,
      widgetId,
      filterByEquipmentUrl,
      sortBy,
      orderByFromHashUrl,
      setUrlToPageOneWithFilter,
      fbeEnabled,
      partNumber,
      activeFacets
    ]
  );
  const [appliedFacets, setAppliedFacets] = useState(activeFacets);
  const restoreInitialActiveFacets = useCallback(() => {
    dispatch(
      marketingSetQueryParam(
        {
          widgetId: widgetId,
          data: {
            activeFacets: appliedFacets ? appliedFacets : [],
            pageNumber: 1,
            batchPartNumbers: []
          }
        },
        true
      )
    );
  }, [appliedFacets]);
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  useEffect(() => {
    if (!isOpen && !isMD) {
      restoreInitialActiveFacets();
    }
  }, [isOpen, isMD, restoreInitialActiveFacets]);

  const showSpecificationsModal = useCallback(() => {
    setAppliedFacets(activeFacets);
    const title = t('Filter_And_Sort');
    const onOpen = () => setIsOpen(true);
    const onClose = () => {
      setIsOpen(false);
    };
    addModalWithOptions(
      <ProductSpecificationModalContainer
        widgetId={widgetId}
        handleCancelButton={handleCancelButton}
        title={title}
        removeCurrentModal={removeCurrentModal}
        setExpanded={setMarketingProductCardExpanded}
        orderBy={sortBy}
        productsArrayLength={productsArrayLength}
        queryActionParam={marketingSetQueryParam}
        activeFacets={activeFacets}
        unitOfMeasure={unitOfMeasure}
        showSpecificationsToggle={showSpecificationsToggle}
        detailsStatus={getProductDetailsStatus}
        appliedFacets={activeFacets}
        setAppliedFacets={setAppliedFacets}
        showLeftNav={showLeftNav}
        isModal
        fbeEnabled
      />,
      {
        isRequired: false,
        onOpen,
        onClose,
        title
      }
    );
  }, [
    addModalWithOptions,
    removeCurrentModal,
    t,
    productCardExpandedArr,
    productsArrayLength,
    activeFacets
  ]);

  useEffect(() => {
    if (isOpen && isMD) {
      removeCurrentModal();
    }
  }, [isMD, isOpen, removeCurrentModal]);

  return (
    <div className="container px-0">
      <h2 className="h2 display-3">
        {widgetHeaderName ? widgetHeaderName : t('SHOP_PARTS')}
      </h2>
      <div
        className={cx('d-flex justify-content-between height-50px', {
          ' align-items-baseline': !isMD
        })}
      >
        <div>
          <ProductListItemsCount
            currentItemsCount={productsArrayLength}
            totalItemsCount={recordSetTotal}
          />
        </div>
        {productsArrayLength > 0 && (
          <div>
            {isMD ? (
              <ProductListSortBy
                sortByAction={marketingSetQueryParam}
                widgetId={widgetId}
                orderBy={sortBy}
                setExpanded={setMarketingProductCardExpanded}
                filterByEquipment={filterByEquipment}
                setUrlToPageOneWithFilter={setUrlToPageOneWithFilter}
                fbeEnabled={fbeEnabled}
                activeFacets={activeFacets}
                isMarketingPage
                partNumbers={partNumbers}
              />
            ) : (
              <AlloyButton
                buttonType="ghost"
                size="large"
                onClick={showSpecificationsModal}
                className="text-nowrap py-2 px-0 ms-2"
              >
                {activeFacets?.length > 0 && (
                  <span className="me-2 u-fs--16" data-testid="facets-counter">
                    ({activeFacets.length})
                  </span>
                )}

                {t('Filter_And_Sort')}
                <FilterIcon className="ms-1" />
              </AlloyButton>
            )}
          </div>
        )}
      </div>

      <div className="row mx-0 mb-3">
        {showLeftNav && (
          <ProductCardSidebar
            productsArrayLength={productsArrayLength}
            totalPartNumber={totalPartNumber}
            widgetId={widgetId}
            handleEquipmentCheck={handleEquipmentCheck}
            showLeftNav={showLeftNav}
          />
        )}
        <div
          className={cx('col-12 px-0 ', {
            'ps-md-3 col-md-9': showLeftNav
          })}
        >
          {isMD && (
            <ProductListFilterBoxes
              activeFacets={activeFacets}
              queryActionParam={marketingSetQueryParam}
              widgetId={widgetId}
              setUrlToPageOneWithFilter={setUrlToPageOneWithFilter}
              fbeEnabled={fbeEnabled}
            />
          )}
          {(() => {
            if (hasCatalogEntries) {
              return (
                <ProductComparisonGrid
                  productsArray={productsArray}
                  isCanonicalUrl={false}
                  preventProductReload={true}
                  priceAndAvailibiltyStatus={priceAndAvailibiltyStatus}
                  priceAndAvailability={priceAndAvailability}
                  domain={ERROR_DOMAIN.MARKETING}
                  path={ERROR_PATH.MAIN}
                  handleSetExpanded={handleSetExpanded}
                  productCardExpandedArr={productCardExpandedArr}
                  isMarketingCards={true}
                  showLeftNav={showLeftNav}
                  gaListName={GA_TRACKING_MARKETING_PRODUCT_CARD}
                  unitOfMeasure={unitOfMeasure}
                  facets={facets}
                />
              );
            } else if (
              selectedEquipment &&
              filterByEquipment &&
              getProductDetailsStatus !== STATUS.PENDING
            ) {
              return <EquipmentNoResults onCheck={handleEquipmentCheck} />;
            } else {
              return null;
            }
          })()}

          {recordSetTotal > productsArrayLength &&
            productsArrayLength >= MARKETING_PRODUCT_PAGE_SIZE && (
              <div className="text-center mt-3">
                {loading && <Loader size="small" className="mb-3" />}
                <AlloyButton
                  buttonType="secondary"
                  data-testid="loadMore"
                  onClick={handleShowMoreClick}
                  disabled={loading}
                  className={'btn btn-secondary btn-dynamic'}
                >
                  {t('LOAD_MORE')}
                </AlloyButton>
              </div>
            )}
          {showKeyComponent && (
            <ProductListKey hasCatalogEntries={hasCatalogEntries} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCardGrid;
